var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-6 py-2 mb-1 grey lighten-4 text--secondary rounded-xl module",domProps:{"textContent":_vm._s(_vm.address)}}),_c('div',{staticClass:"caption grey--text px-3"},[_vm._v(" Address ")])])}
var staticRenderFns = []

export { render, staticRenderFns }